export const config = {
  apiUrl: "https://api-faucet.venom.foundation/api",
  reCaptchaKey: "6LcBcEchAAAAAFh0nZyDH5GLOHn8AKTGl6_WGEDb",
  clientId: "f24f00699a2db5aa385d",
  maintenanceMode: false,
  defaultNetworkName: 'Testnet',
};
